import React from 'react';
import { CustomTableToolbarSelect } from 'hooks/multipleSelection';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { SvgDeleteFilled } from 'UI/res';
import { getFeatureFlags } from 'UI/utils';

import { useStyles } from '../styles';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {Function} props.onRemoveClick
 * @param {number} props.searchProjectIdInPreview
 * @param {string} props.searchProjectNameInPreview
 * @param {Function} props.onRemoveSuccess
 * @param {number} props.totalSelected
 */
const ActionsToolbar = ({
  children,
  onRemoveClick,
  searchProjectIdInPreview,
  searchProjectNameInPreview,
  onRemoveSuccess,
  totalSelected
}) => {
  const styles = useStyles();

  const isRemoveEnabled = getFeatureFlags().includes(FeatureFlags.EnableRemoveInBulkTables);

  if (!totalSelected) return null;

  return (
    <CustomTableToolbarSelect total={totalSelected}>
      <div className={styles.ActionsToolbar}>
        {children}
        {isRemoveEnabled && (
          <FPIconButton
            onClick={onRemoveClick({
              id: searchProjectIdInPreview,
              dialogCopies: {
                title: 'Remove Selected Items',
                message: strings.formatString(
                  strings.searchProjects.preview.dialogs.removeItems.message,
                  {
                    spName: searchProjectNameInPreview
                  }
                ),
                confirmButtonText: 'Remove',
                cancelButtonText: 'Keep'
              },
              onRemove: () => {
                onRemoveSuccess();
              }
            })}
            tooltipProps={{
              title: strings.searchProjects.preview.buttons.removeItems,
              placement: 'bottom'
            }}
            icon={SvgDeleteFilled}
            iconProps={{
              onSetColor: palette => palette.primary.main
            }}
          />
        )}
      </div>
    </CustomTableToolbarSelect>
  );
};

export default ActionsToolbar;
